function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import track from "../../../track";
var MBOX_ACTIVE_EVENT_ID = 276;
var MBOX_USED_EVENT_ID = 275;
var MBOX_RESPONSE_TYPE_EVENT_ID = 279;
var MBOX_RESPONSE_FEATURES_EVENT_ID = 280;
var TOTAL_MBOX_ACTIVE_EVENT_ID = 262;
var TOTAL_MBOX_USED_EVENT_ID = 266;
var GLOBAL_PARAMETER_COUNT_EVENT_ID = null;
var PAGE_PARAMETER_COUNT_EVENT_ID = null;
var MBOX_PARAMETER_COUNT_EVENT_ID = null;
var MBOX_PROFILE_PARAMETER_COUNT_EVENT_ID = null;
export var trackGlobalParameters = /*#__PURE__*/ _async_to_generator(function(globalParameters) {
    return _ts_generator(this, function(_state) {
        if (globalParameters === void 0) globalParameters = {};
        return [
            2,
            track(GLOBAL_PARAMETER_COUNT_EVENT_ID, Object.keys(globalParameters).length)
        ];
    });
});
export var trackPageParameters = /*#__PURE__*/ _async_to_generator(function(pageParameters) {
    return _ts_generator(this, function(_state) {
        if (pageParameters === void 0) pageParameters = {};
        // Not sure if we actually care what the parameters or, or their values since these aren't defined inside lapel
        // Just knowing how many parameters are being used seems reasonable so we can detect if it's becoming too much (over 50)
        return [
            2,
            track(PAGE_PARAMETER_COUNT_EVENT_ID, Object.keys(pageParameters).length)
        ];
    });
});
export var trackMboxFeatures = /*#__PURE__*/ _async_to_generator(function(param) {
    var tmp, _ref, _ref_, type, content, features, promises;
    return _ts_generator(this, function(_state) {
        tmp = param.options, _ref = _sliced_to_array(tmp === void 0 ? [
            {}
        ] : tmp, 1), _ref_ = _ref[0], type = _ref_.type, content = _ref_.content;
        features = new Set([
            "evar",
            "evarValue",
            "props",
            "cookies",
            "storage",
            "tunnel",
            "component",
            "remote",
            "mergeChildProps",
            "script"
        ]);
        promises = [
            track(MBOX_RESPONSE_TYPE_EVENT_ID, type)
        ];
        if (content && typeof content === "object") {
            Object.keys(content).forEach(function(key) {
                if (features.has(key)) {
                    promises.push(track(MBOX_RESPONSE_FEATURES_EVENT_ID, key));
                }
            });
        }
        return [
            2,
            Promise.all(promises)
        ];
    });
});
export var trackMboxParameters = /*#__PURE__*/ _async_to_generator(function(param) {
    var _param_parameters, parameters;
    return _ts_generator(this, function(_state) {
        _param_parameters = param.parameters, parameters = _param_parameters === void 0 ? {} : _param_parameters;
        return [
            2,
            track(MBOX_PARAMETER_COUNT_EVENT_ID, Object.keys(parameters).length)
        ];
    });
});
export var trackMboxProfileParameters = /*#__PURE__*/ _async_to_generator(function(param) {
    var _param_profileParameters, profileParameters;
    return _ts_generator(this, function(_state) {
        _param_profileParameters = param.profileParameters, profileParameters = _param_profileParameters === void 0 ? {} : _param_profileParameters;
        return [
            2,
            track(MBOX_PROFILE_PARAMETER_COUNT_EVENT_ID, Object.keys(profileParameters).length)
        ];
    });
});
export var trackMboxResult = /*#__PURE__*/ _async_to_generator(function(mbox) {
    var name, options, promises;
    return _ts_generator(this, function(_state) {
        name = mbox.name, options = mbox.options;
        promises = [];
        promises.push(track(MBOX_USED_EVENT_ID, name, false));
        if (options) {
            promises.push(track(MBOX_ACTIVE_EVENT_ID, name, false));
            promises.push(trackMboxFeatures(mbox));
        }
        return [
            2,
            Promise.all(promises)
        ];
    });
});
export var trackMboxRequest = /*#__PURE__*/ _async_to_generator(function(toFetch, globalParameters, pageParameters) {
    return _ts_generator(this, function(_state) {
        if (toFetch === void 0) toFetch = [];
        if (globalParameters === void 0) globalParameters = {};
        if (pageParameters === void 0) pageParameters = {};
        return [
            2,
            Promise.all([
                trackGlobalParameters(globalParameters),
                trackPageParameters(pageParameters),
                toFetch.map(function(mbox) {
                    return Promise.all([
                        trackMboxParameters(mbox),
                        trackMboxProfileParameters(mbox)
                    ]);
                })
            ])
        ];
    });
});
export var trackMboxResults = /*#__PURE__*/ _async_to_generator(function(fetched) {
    var promises, active;
    return _ts_generator(this, function(_state) {
        if (fetched === void 0) fetched = [];
        promises = [
            track(TOTAL_MBOX_USED_EVENT_ID, fetched.length)
        ];
        active = 0;
        fetched.forEach(function(mbox) {
            if (mbox.options) {
                active += 1;
            }
            promises.push(trackMboxResult(mbox));
        });
        promises.push(track(TOTAL_MBOX_ACTIVE_EVENT_ID, active));
        return [
            2,
            Promise.all(promises)
        ];
    });
});

//# sourceMappingURL=analytics.js.map